type ToastVariants = 'success' | 'error';

export const toastVariant = (
  remixToastType: 'info' | 'success' | 'error' | 'warning'
): ToastVariants => {
  if (['error', 'warning'].includes(remixToastType)) {
    return 'error';
  }
  return 'success';
};
